import React, { Component } from "react";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import MyCard from "./card";
import { updateSelectCard, updateSelectArea, updateBatchSource, updateAreaList, setAreaItemVisible, updateSearchBox } from "Store/ZoneSetting/action";
import BatchSettingModal from "./batchSettingModal";
import AddNotMetaDataModal from "./addNotMetaDataModal";
import { DragSource, DropTarget } from 'react-dnd';
import { langCheck } from 'Pub/js/utils';
import {
    addNewAreaItem,
    removeSelectCardCls,
    findRepeatItemsByCode,
    checkAreaType,
    TAB_FLAG,
    subscribeSetActiveKey,
    pubSubAction,
} from "./events";
import Notice from "Components/Notice";
import FormGroupArea from './components/FormGroupArea';
import TableFoldArea from './components/TableFoldArea';
import TableDrawerArea from './components/TableDrawerArea';
import GrandsonArea from './components/GrandsonArea';
import BaseAreaItem from './components/BaseAreaItem';
import AreaSyncModal from './components/AreaSync';
import platform from "Pub/js/platform";
import { processClass } from './components/LeftSideMetaTree/util';
import _ from 'lodash';
import { getMultiLangText, getMultiLangValues } from './utilService';

const { NCDiv, NCPopconfirm, NCCheckbox, NCButton } = platform.base;
const { PubSub } = platform;

//阻止冒泡
const handleStopPropagation = callback => e => {
    e && e.stopPropagation();
    return callback && callback();
};
//区域组件类
const areaSource = {
    beginDrag(props) {
        if (!props.isImplement) {
            props.updateSelectArea(props.areaItem); //拖拽时选中当前区域
            removeSelectCardCls(); //清空选中字段样式
        }
        return {
            id: props.id,
            index: props.index,
            type: props.type,
        };
    },
    canDrag(props) {
        //实施态禁止拖动区域
        return !props.isImplement;
    },
};

const areaTarget = {
    drop(props, monitor, component) {
        const dragItem = monitor.getItem();
        //从左侧拖拽非元数据
        if (dragItem.type === 'card') {
            //实施态查询区不让拖非元数据
            if (props.isImplement && props.areatype === '0') {return;}
            component.openAddNotMetaInArea();
            //只拖拽到区域时执行（而不是嵌套组件）
            if (monitor.isOver({ shallow: false })) {
                let realAreaIndex = props.index;
                //拖拽到多页签子表头部时
                if (component.state.tabObj.activeTabKey) {
                    const currentTabAreaIndex = component.getAreaIndexByPk(component.getCurrentTabArea());
                    realAreaIndex = currentTabAreaIndex;
                }
                component.setState({
                    currentNotMeta: { datatype: dragItem.datatype },
                    realAreaIndex,
                });
            }
        } else if (dragItem.from !== 'left') {
            const dragIndex = dragItem.index;
            const hoverIndex = props.index;

            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {return;}

            props.onDragArea(dragIndex, hoverIndex);
            monitor.getItem().index = hoverIndex;
        }
    },
};

//DropSource用于包装你需要拖动的组件，使组件能够被拖拽
@DragSource('area', areaSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
}))
//DropTarget用于包装接收拖拽元素的组件，使组件能够放置
@DropTarget('area', areaTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}))
class AreaItem extends Component {
    constructor(props) {
        super(props);
        this.defaultState = {
            sideObj: { //侧拉
                sideShow: false,
                emptyArea: {}, //缓存新增的侧拉区
            },
        };
        this.state = {
            batchSettingModalVisibel: false,
            addDataModalVisibel: false,
            currentNotMeta: {}, //当前拖拽的非元数据
            realAreaIndex: props.index, //自定义区域对应areaList的index
            groupShowArr: this.initFormGroupShowArr(), //表单区分组显示
            //以下状态不放组件内部原因是排序是需要保留状态
            foldObj: props.areaItem.sides ? { //表单区展开卡片
                foldShow: false,
                emptyArea: {}, //缓存新增的展开卡片区
            } : {},
            sideObj: props.areaItem.sides ? _.clone(this.defaultState.sideObj) : {},
            grandsonObj: { //孙表
                grandsonShowArr: props.areaItem.grandsons ? [...props.areaItem.grandsons].fill(true) : [], //孙表区域显示
                isTileArr: props.areaItem.grandsons ? [...props.areaItem.grandsons].fill(false) : [], //孙表切换视图
            },
            tabObj: { //多页签子表
                // activeTabKey: '', //当前选中的页签
                activeTabKey: props.selectedArea ? props.selectedArea.code : '',
                sideArr: props.areaItem.tabs ? [...props.areaItem.tabs].fill(_.clone(this.defaultState.sideObj)) : [], //多页签侧拉
            },
            checkedCards: { [props.id]: [] }, //已选中的卡片
            showCardCheckboxController: { [props.id]: false }, //控制哪个区域显示多选框
            syncSettingModalVisible: false, // 批量同步设置模态框
        };
        this.setBlankDomWidth = this.setBlankDomWidth.bind(this);
    }

    componentDidMount() {
        //只有一个区域时默认展开
        if (this.props.areaListLength == 1) {
            this.showOrHideAreaItem(true);
        }
        //切换多页签关联区域时选中对应页签
        this.pubsub = subscribeSetActiveKey(this.props.areaItem, this.setActiveTabKey);
        //监听保存事件
        this.savepubsub = PubSub.subscribe(pubSubAction.isSave, () => {
            //保存后收起侧拉
            if (this.state.sideObj.sideShow) {
                this.handleToggleSideForm();
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        const preTabsLen = this.props.areaItem.tabs ? this.props.areaItem.tabs.length : 0;
        //新增页签后更新侧拉state
        if (nextProps.areaItem.tabs) {
            if (Array.isArray(nextProps.areaItem.tabs) && nextProps.areaItem.tabs.length > preTabsLen) {
                const { tabObj } = this.state;
                tabObj.sideArr = [...nextProps.areaItem.tabs].fill(_.clone(this.defaultState.sideObj));
                this.setState({ tabObj });
            }
        }
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.pubsub); //移除订阅
        PubSub.unsubscribe(this.savepubsub); //移除订阅
        this.areaItemDom = null;
    }

    //移动卡片（旧版）
    // moveCard = (dragIndex, hoverIndex) => {
    //     this.props.moveCard(dragIndex, hoverIndex, this.props.index);
    // };
    /**
     * 移动卡片
     * @param {Number} dragIndex 拖拽卡片的index
     * @param {Number} hoverIndex 目标卡片的index
     * @param {Number} areaIndex 区域的index
     **/
    moveCard = (dragIndex, hoverIndex, areaIndex) => {
        let { areaList } = this.props;
        areaList = _.cloneDeep(areaList);
        const cards = areaList[areaIndex].queryPropertyList;

        const dragCard = cards[dragIndex];
        cards.splice(dragIndex, 1);
        cards.splice(hoverIndex, 0, dragCard);
        _.forEach(cards, (q, i) => {
            q.position = i + 1;
        });
        this.props.updateAreaList(areaList);
        // this.props.updateSelectCard({}); //出于性能考虑注掉
    };

    /**
     * 删除卡片
     *
     * @param cardIndex - 卡片index
     * @param areaIndex - 区域index
     */
    deleteCard = (cardIndex, areaIndex) => {
        this.props.deleteCard(cardIndex, areaIndex);
    };
    //新增元数据 areaId:分组对应的区域id
    addMetaInArea = ({
        metaId = this.props.areaItem.metaid,
        areaId = this.props.id,
        areaType = this.props.areatype,
    } = {}) => {
        this.props.addMetaInArea(
            metaId,
            // this.props.metaid,
            areaId,
            areaType,
        );
    };
    //选择某个卡片
    // selectThisCard = (e, cardIndex) => {
    //     this.props.selectThisCard(e, cardIndex, this.props.index);
    // };
    //打开批量设置模态框
    openBatchSetting = areaIndex => {
        this.props.updateSelectCard({});
        this.setModalVisibel(true, areaIndex);
    };
    //设置批量设置模态框的显示/隐藏
    setModalVisibel = (visibel, areaIndex) => {
        const { areaList, index } = this.props;
        let newIndex = areaIndex || index;
        this.props.updateBatchSource(areaList[newIndex].queryPropertyList);
        this.setState({
            batchSettingModalVisibel: visibel,
            realAreaIndex: newIndex,
        });
    };

    // 打开批量同步设置模态框
    openSyncSetting = areaIndex => {
        this.setState({
            syncSettingModalVisible: true,
            syncAreaIndex: areaIndex,
        });
    }
    // 设置批量同步设置模态框的显示/隐藏

    setSyncModalVisible = type => {
        this.setState({ syncSettingModalVisible: type });
    }
    //打开新增非元数据模态框
    openAddNotMetaInArea = () => {
        this.setAddDataModalVisibel(true);
    };
    //设置新增非元数据模态框的显示/隐藏
    setAddDataModalVisibel = visibel => {
        this.setState({ addDataModalVisibel: visibel });
    };

    //根据区域id查区域index
    getAreaIndexByPk = area => {
        if (!area) {return;}
        let areaIndex;
        this.props.areaList.map((item, index) => {
            if (item.pk_area === area.pk_area) {
                areaIndex = index;
            }
        });
        return areaIndex;
    }

    //显示/隐藏整个区域
    showOrHideAreaItem = flag => {
        let isShow = typeof flag !== 'boolean' ? !this.props.isShow : flag;
        this.props.onExpandArea(this.props.index, isShow);
    };

    //显示/隐藏表单区分组
    toggleFormGroup = (index, code, e) => {
        let { groupShowArr } = this.state;
        e && e.stopPropagation();
        // 增加多页签处理
        let newArr = groupShowArr.map(el => {
            if (el[0] === code) {
                el[1][index] = !el[1][index];
            }
            return el;
        });
        this.setState({ groupShowArr: newArr });
    }

    //清空选中字段
    clearSelectCard = () => {
        removeSelectCardCls();
        this.props.updateSelectCard({});
    }

    //选中区域
    selectAreaItem = (e, area = this.props.areaItem) => {
        e && e.stopPropagation();
        const { selectCard, selectedArea } = this.props;
        if (!_.isEmpty(selectCard)) {this.clearSelectCard();}//清空选中字段
        if (selectedArea && area.pk_area !== selectedArea.pk_area) {this.props.updateSelectArea(area);}
    }

    //检查区域编码是否重复
    checkAreaCodeRepeat = areaList => {
        const repeatArea = findRepeatItemsByCode(areaList); //重复的区域编码
        if (repeatArea && repeatArea.length > 0) {
            let repeatNames = repeatArea.map(item => item.name);
            Notice({ status: 'error', msg: `${langCheck('ZoneSetting-000046', "pages", this.props.json)}${JSON.stringify(repeatNames)}${langCheck('102202APP-000011', "pages", this.props.json)}` }); /* 国际化处理： 编码不能重复*/
            return true;
        }
        return false;
    }

    //新增表单区分组 position:新增分组的位置
    handleAddFormGroup = (e, position) => {
        e.stopPropagation();
        const areaItem = this.getCurrentTabArea();
        const relationcode = areaItem.code;
        // const groupPosition = _.findLastIndex(this.props.areaList, item => item.relationcode === relationcode) + 1;
        const groupPosition = _.findLastIndex(this.props.areaList, item => item.code === relationcode) + 1;
        //主表未展开时新增分组展开主表
        // if (!this.props.isShow) {
        //     this.showOrHideAreaItem(true);
        // }
        // this.setActiveTabKey(relationcode);
        // if (relationcode === this.props.selectedArea.code) {
        //     this.showOrHideAreaItem(true);
        // }
        //异步目的是展开区域后再执行
        setTimeout(() => {
            let addArea = this.addArea(this.props, {
                items: {
                    areatype: '1',
                    relationcode,
                },
                position: position || groupPosition,
            });
            let curAreaItem = this.getCurrentTabArea();
            this.setActiveTabKey(relationcode);
            if (addArea && position === undefined) {
                //主表区域新增分组滚动到新增的分组上
                let lastFormGroupElm = this[`formGroupRef${areaItem.groups.length - 1}`];
                lastFormGroupElm && lastFormGroupElm.scrollIntoView();
            }
        }, 0);
    }
    /**
     * 表单区分组，由于表单区域多页签也要有分组，所以原来的状态值不适用。
     * 增加状态值状态存储
     */
    initFormGroupShowArr = () => {
        let { areaItem } = this.props;
        let { code, groups, formTabs } = areaItem;
        let showArr = [];
        showArr.push([code, groups ? [...groups].fill(true) : []]);
        if (formTabs && formTabs.length > 0) {
            formTabs.forEach(tab => {
                showArr.push([tab.code, tab.groups ? [...tab.groups].fill(true) : []]);
            });
        }
        return showArr;
    }

    //隐藏不显示属性
    handleHideGray = (val, areaItem = this.props.areaItem) => {
        const pk_area = areaItem.pk_area || this.props.areaItem.pk_area;
        this.props.setAreaItemVisible({ ...this.props.areaVisible, [pk_area]: val });
    }

    //获取分组展开状态
    getGroupContentVisible = (groupIndex, code) => {
        let { groupShowArr } = this.state;
        let curGroups = groupShowArr.find(el => el[0] === code);
        // 增加多页签处理
        return curGroups ? (curGroups[1][groupIndex] || groupIndex >= curGroups[1].length) : true;
    }

    //获取孙表展开状态
    getGrandsonContentVisible = grandsonIndex => {
        const { grandsonShowArr } = this.state.grandsonObj;
        return grandsonShowArr[grandsonIndex] || grandsonIndex >= grandsonShowArr.length; //新增分组后index会增加
    }

    /**
     * 非元数据拖拽到特殊区域的回调
     *
     * @monitor dropTarget的monitor
     * @areaIndex 实际区域index
     */
    handleSpecialAreaDrop = (monitor, areaIndex) => {
        const dragItem = monitor.getItem();
        this.openAddNotMetaInArea();
        this.setState({
            realAreaIndex: areaIndex,
            currentNotMeta: { datatype: dragItem.datatype },
        });
    }

    /**
     * 检查区域是否在首尾
     *
     * @param type - 头部/尾部。必传
     * @param index - 区域index。必传
     * @param child - 子区域数据（分组/侧拉/孙表）。选传
     */
    checkAreaIsBeginOrEnd = ({ type, index, child }) => {
        const areaItem = this.getCurrentTabArea();
        const currArea = this.props.areaList[index]; //当前区域
        const notNullArea = this.props.newAreaList.filter(item => item !== null);
        const firstArea = notNullArea[0];
        const lastArea = notNullArea[notNullArea.length - 1];
        const childType = child && Object.keys(child)[0];
        const childArea = child && Object.values(child)[0];
        const children = childType && areaItem[childType];
        //检测区域在头部
        if (type === 'begin') {
            if (childArea) {
                return children && children[0] && children[0].pk_area === childArea.pk_area;
            } else {
                return firstArea.pk_area === currArea.pk_area;
            }
        } else if (type === 'end') {
            //检测区域在尾部
            if (childArea) {
                return children && children[children.length - 1] && children[children.length - 1].pk_area === childArea.pk_area;
            } else {
                return lastArea.pk_area === currArea.pk_area;
            }
        }
    }

    //删除区域
    handleDeleteArea = areaId => {
        return new Promise(resolve => {
            let deleteCallback;
            const { areaItem, onDeleteArea } = this.props;
            if (areaItem.groups && areaItem.groups.length > 0) {
                /* 国际化处理： 请注意修改分组的关联区域编码*/
                deleteCallback = () => Notice({ status: "warning", msg: langCheck('ZoneSetting-000210', 'pages', this.props.json) });
            }
            onDeleteArea(areaId, deleteCallback);
            this.props.updateSelectArea({});
            resolve();
        });
    }

    //封装新增区域方法 增加区域编码重复校验
    addArea = (...args) => {
        //区域编码重复
        if (this.checkAreaCodeRepeat(this.props.areaList)) {
            return false;
        }
        return addNewAreaItem.apply(this, args);
    }

    //展开卡片
    handleToggleFoldForm = (e, areaItem = this.props.areaItem) => {
        let { foldObj } = this.state;
        let foldArea = areaItem.sides && areaItem.sides.find(item => item.areastatus === 'browse');
        //区域编码重复
        if (this.checkAreaCodeRepeat(this.props.areaList)) {
            return;
        }
        if (!this.props.isImplement && !foldArea) {
            //没有展开卡片新增一个
            foldArea = this.addArea(this.props, {
                items: {
                    areatype: '1',
                    areastatus: 'browse',
                    relationcode: areaItem.code,
                },
            });
            foldObj.emptyArea = _.cloneDeep(foldArea); //缓存新增的区域
        }
        foldObj.foldShow = !foldObj.foldShow;
        this.setState({ foldObj }, () => {
            if (!this.state.foldObj.foldShow) {
                //新增的区域没做修改收起时删掉
                if (!this.props.isImplement && _.isEqual(foldArea, this.state.foldObj.emptyArea)) {
                    this.handleDeleteArea(foldArea.pk_area);
                }
                this.props.updateSelectArea({});
            } else {
                //区域没展开时展开区域
                if (!this.props.isShow) {
                    setTimeout(() => {
                        this.props.onExpandArea(this.props.index, true);
                    }, 0);
                }
            }
        });
        this.selectAreaItem(e, foldArea);
    }

    //展开侧拉
    handleToggleSideForm = (e, areaItem = this.props.areaItem) => {
        let { sideObj } = this.state;
        let tabObj = _.cloneDeep(this.state.tabObj);
        let sideArea = areaItem.sides && areaItem.sides.find(item => item.areastatus === 'edit');
        const hasGrandsonArea = areaItem.grandsons && areaItem.grandsons.length > 0; //该子表有孙表
        //没有侧拉新增一个侧拉区
        if (!this.props.isImplement && !sideArea && !hasGrandsonArea) {
            sideArea = this.addArea(this.props, {
                items: {
                    areatype: '1',
                    areastatus: 'edit',
                    relationcode: areaItem.code,
                },
            });
            sideObj.emptyArea = _.cloneDeep(sideArea); //缓存新增的区域
        }
        if (sideArea || hasGrandsonArea) {
            if (!sideArea) {sideArea = areaItem;} //没有侧拉时侧拉区域显示子表信息
            //多页签子表
            if (checkAreaType.isTableTab(areaItem) && this.props.areaItem.tabs) {
                const tabIndex = this.props.areaItem.tabs.findIndex(item => item.pk_area === areaItem.pk_area);
                // fixed NCC-199203多页签子表展开侧拉有误
                const newSideArr = tabObj.sideArr.map((s, i) => {
                    let newItem = _.cloneDeep(s);
                    if (i === tabIndex) {
                        newItem.sideShow = !newItem.sideShow;
                    }
                    return newItem;
                });
                tabObj.sideArr = newSideArr;
                // tabObj.sideArr[tabIndex].sideShow = !tabObj.sideArr[tabIndex].sideShow;
                this.setState({ tabObj }, toggleCallback.bind(this, tabObj.sideArr[tabIndex]));
            } else {
                tabObj.sideArr = tabObj.sideArr.map(el => {
                    el.sideShow = false;
                    return el;
                });

                sideObj.sideShow = !sideObj.sideShow;
                this.setState({ sideObj, tabObj }, toggleCallback.bind(this, sideObj));
            }
            this.props.updateSearchBox({ showSide: sideObj.sideShow });
        }
        //切换侧拉的回调
        function toggleCallback(sideObj) {
            if (sideObj.sideShow === true) {
                this.selectAreaItem(e, sideArea);
            } else {
                //新增的区域没做修改收起时删掉
                if (!this.props.isImplement && _.isEqual(sideArea, sideObj.emptyArea)) {
                    this.handleDeleteArea(sideArea.pk_area);
                }
                this.props.updateSelectArea({});
            }
        }
    }

    //显示/隐藏孙表
    handleToggleGrandson = index => {
        let { grandsonObj } = this.state;
        grandsonObj.grandsonShowArr[index] = !grandsonObj.grandsonShowArr[index];
        this.setState({ grandsonObj });
    }

    //切换孙表视图
    handleToggleGransonView = index => {
        let { grandsonObj } = this.state;
        grandsonObj.isTileArr[index] = !grandsonObj.isTileArr[index];
        this.setState({ grandsonObj });
    }

    /**
     * 复制区域
     *
     * @param copyItems 需要覆盖的字段
     * @param position 位置
     * @param areaItem 复制的区域
     *
     */
    copyArea = ({ copyItem, position, areaItem }) => {
        const { templetid, code, metaid, metaname, queryPropertyList } = areaItem;
        const queryPropertyListCopy = this.copyAreaProperty(queryPropertyList);
        const commonAreaItemsCopy = {
            relationcode: code,
            templetid,
            metaid,
            metaname,
            queryPropertyList: queryPropertyListCopy,
        };
        let newItem = Object.assign(commonAreaItemsCopy, copyItem);
        return this.addArea(this.props, {
            items: newItem,
            position,
        });
    }

    //复制字段
    copyAreaProperty = queryPropertyList => {
        let result = [];
        queryPropertyList.forEach(copyItem => {
            let newCopyObj = _.cloneDeep(copyItem);
            newCopyObj.pk_form_property = ''; //清空字段主键
            newCopyObj.pk_query_property = ''; //清空字段主键
            newCopyObj.areaid = ''; //清空区域id
            result.push(newCopyObj);
        });
        return result;
    }

    //复制卡片
    handleCopyFoldArea = (copyPosition, areaItem = this.props.areaItem) => {
        let { foldObj } = this.state;
        let copyAreaNames = this.handleCopyMultiLangValues(areaItem, 'name', '_01');
        //区域编码重复
        if (this.checkAreaCodeRepeat(this.props.areaList)) {
            return;
        }
        if (areaItem.sides && areaItem.sides.find(item => item.areastatus === 'browse')) {
            Notice({ status: "warning", msg: langCheck('ZoneSetting-000213', 'pages', this.props.json) });/* 国际化处理： 已经添加过展开卡片了*/
            return;
        }
        const copyArea = this.copyArea({
            copyItem: {
                areatype: '1',
                areastatus: 'browse',
                code: areaItem.code + '_01',
                // name: areaItem.name + '_01',
                // 支持多语文本处理
                ...copyAreaNames,
            },
            position: copyPosition,
            areaItem,
        });
        if (copyArea) {
            foldObj.foldShow = true; //复制卡片后默认展开
            this.setState({ foldObj });
        }
    }

    handleCopyMultiLangValues(item, propertyKey, surfix) {
        let { multiOptions } = this.props;
        let multiLangValues = getMultiLangValues(item, propertyKey, multiOptions);
        multiLangValues = Object.entries(multiLangValues).map(item => {
            return [item[0], _.get(item[1], 'value')];
        });
        multiLangValues = _.map(multiLangValues, el => {
            return [el[0], `${el[1]}${surfix}`];
        });
        let ret = Object.fromEntries(multiLangValues);
        return ret;
    }

    //复制侧拉
    handleCopySideArea = (copyPosition, areaItem = this.props.areaItem) => {
        let { sideObj } = this.state;
        let copyAreaNames = this.handleCopyMultiLangValues(areaItem, 'name', '_02');
        if (areaItem.sides && areaItem.sides.find(item => item.areastatus === 'edit')) {
            Notice({ status: "warning", msg: langCheck('ZoneSetting-000214', 'pages', this.props.json) });/* 国际化处理： 已经添加过展开侧拉了*/
            return;
        }
        const copyArea = this.copyArea({
            copyItem: {
                areatype: '1',
                areastatus: 'edit',
                code: areaItem.code + '_02',
                // name: areaItem.name + '_02',
                // 支持多语文本处理
                ...copyAreaNames,
            },
            position: copyPosition,
            areaItem,
        });
        if (copyArea) {
            if (sideObj.sideShow === false) {
                sideObj.sideShow = true; //复制侧拉后默认展开
                this.props.updateSearchBox({ showSide: true });
                this.setState({ sideObj });
            }
        }
    }

    //新增孙表
    handleAddGrandson = (e, areaItem = this.props.areaItem, position) => {
        e.stopPropagation();
        this.addArea(this.props, {
            items: {
                areatype: '2',
                relationcode: areaItem.code,
                isgrandson: true,
            },
            position,
        });
    }

    //得到区域的className area：指定的区域 areaClassName：区域的className
    getAreaItemCls = (area, areaClassName = "area-item") => {
        if (!area) {return;}
        const { selectedArea, selectCard } = this.props;
        let { tabs, pk_area } = area;
        let isActivedArea = (selectedArea.pk_area === pk_area) || (_.findIndex(tabs, el => el.pk_area === selectedArea.pk_area) > -1);
        let isActivedCardInArea = (selectCard.areaid === pk_area) || (_.findIndex(tabs, el => el.pk_area === selectCard.areaid) > -1);
        //选中区域
        if (selectedArea && isActivedArea === true) {
            areaClassName += ' active';
        } else if (selectCard && isActivedCardInArea === true) {
            areaClassName += ' active card-active';
        }
        return areaClassName;
    }

    //复制卡片
    copyFold = (e, areaItem = this.props.areaItem) => {
        e.stopPropagation();
        if (!areaItem.code) {return;}
        this.handleCopyFoldArea(this.props.index + 1, areaItem);
    }

    //复制侧拉
    copySide = (e, areaItem = this.props.areaItem) => {
        e.stopPropagation();
        if (!areaItem.code) {return;}
        this.handleCopySideArea(this.props.index + 1, areaItem);
    }

    //判断是否多页签 type:table 子表 form:主表
    isTabs = (type, areaItem = this.props.areaItem) => {
        return areaItem[TAB_FLAG[type]] && areaItem[TAB_FLAG[type]].length > 0;
    }

    /**
     * 渲染头部按钮
     *
     * @type 头部类型 - area：区域 group：分组
     * @params 按钮事件
     */
    renderHeaderBtns = (type = 'area', params = {}) => {
        let { json, index, isImplement, areaItem, zoneFormData, areatype, areaList } = this.props;
        const implementHideBtns = [
            'onAddFormGroup',
            'onCopySideArea',
            'onCopyFoldArea',
            'onMoveDown',
            'onMoveUp',
            'onAddGrandsonTable',
            'onDelete',
        ];
        //实施态隐藏区域操作的按钮
        if (isImplement) {
            implementHideBtns.forEach(btn => delete params[btn]);
        }
        const iconCls = type === 'side' ? 'opr-btn' : 'opr-btn icon-btn';
        const btnCls = type !== 'group' && type !== 'side' ? ' float' : '';
        let {
            child, //子区域数据（分组、侧拉、孙表）
            hasMeta, //是否可以添加元数据
            foldBtnVisible, //展开侧拉/展开卡片按钮显隐
            toggleViewBtnVisible, //切换视图按钮
            isTile = areaItem.isTile, //切换视图状态
            onHideGray, //隐藏不显示属性
            onAddMeta, //新增元数据
            onBatchSetting, //批量设置
            onSyncSetting, // 批量同步设置
            onAddFormGroup, //新增分组
            onCopySideArea, //复制侧拉
            onCopyFoldArea, //复制卡片
            onMoveDown, //下移
            onMoveUp, //上移
            onAddGrandsonTable, //新增孙表
            onDelete, //删除
            onToggleView, //切换视图
            currentPkArea, // 当前 pk_area
            onToggleSide, //展开侧拉
            onToggleFold, //展开下拉
        } = params;
        let currentArea = areaList.find(item => item.pk_area == currentPkArea);
        const isFirstArea = this.checkAreaIsBeginOrEnd({ type: 'begin', index, child }); //是否第一个区域
        const isLastArea = this.checkAreaIsBeginOrEnd({ type: 'end', index, child }); //是否最后一个区域
        if (child !== undefined) {index = this.getAreaIndexByPk(child);}
        return (
            <span className={`area-item-button${btnCls}`} onClick={e => e.stopPropagation()}> {/* 这里阻止冒泡目的是防止点按钮时选中区域 */}
                <NCCheckbox checked={this.props.areaVisible[currentPkArea] || false} onChange={onHideGray} >
                    {langCheck('ZoneSetting-000013', 'pages', json)}
                    {/* /* 国际化处理： 隐藏不显示属性*/}
                </NCCheckbox>
                {
                    isImplement ? null :
                        hasMeta() ?
                            <a onClick={onAddMeta}>{langCheck('ZoneSetting-000014', 'pages', json)}</a> /* 国际化处理： 新增元数据*/
                            :
                            <Tooltip placement="top" title={langCheck('ZoneSetting-000203', 'pages', json)}> {/* 国际化处理：请先关联元数据*/}
                                <a className="disabled">{langCheck('ZoneSetting-000014', 'pages', json)}</a> {/* 国际化处理： 新增元数据*/}
                            </Tooltip>
                }
                {/* /* 国际化处理： 批量设置*/}
                <a onClick={onBatchSetting}>{langCheck('ZoneSetting-000015', 'pages', json)}</a>

                {/* /* 国际化处理： 批量同步设置*/}
                {
                    isImplement ? (
                        onSyncSetting && <a onClick={onSyncSetting}>{langCheck('ZoneSetting-000261', 'pages', json)}</a>
                    ) : (
                    // 暂时先隐藏  待UE确认

                        currentArea && !currentArea.newArea ?
                            onSyncSetting && <a onClick={onSyncSetting}>{langCheck('ZoneSetting-000261', 'pages', json)}</a> :
                            onSyncSetting && <a className="disabled">{langCheck('ZoneSetting-000261', 'pages', json)}</a>
                    // null
                    )

                }
                {/* 展开侧拉/展开卡片 */}
                {
                    foldBtnVisible && this.renderTableOperateCol(onToggleSide, onToggleFold)
                }
                {/* 表单区域显示新增分组 */}
                {
                    areaItem.code === (zoneFormData && zoneFormData.headcode) && onAddFormGroup &&
                    <span className={iconCls} onClick={onAddFormGroup}>
                        <i
                            title={langCheck('ZoneSetting-000209', 'pages', json)} /* 国际化处理： 新增分组*/
                            className="iconfont icon-xinzengfenzu"
                        />
                    </span>
                }
                {
                    (onCopySideArea && onCopyFoldArea) &&
                    <span className="btn-group">
                        {/* 复制侧拉 */}
                        {
                            areaItem.code && onCopySideArea ?
                                <span className={iconCls} onClick={onCopySideArea}>
                                    <i className="iconfont icon-fuzhicela" title={langCheck('ZoneSetting-000211', 'pages', json)} /> {/* 国际化处理： 复制侧拉*/}
                                </span>
                                :
                                <Tooltip className={iconCls} placement="top" title={langCheck('ZoneSetting-000221', 'pages', json)}> {/* 国际化处理：请先输入区域编码*/}
                                    <span onClick={onCopySideArea}>
                                        <i className="iconfont icon-fuzhicela disabled" title={langCheck('ZoneSetting-000211', 'pages', json)} /> {/* 国际化处理： 复制侧拉*/}
                                    </span>
                                </Tooltip>
                        }
                        {/* 复制卡片 */}
                        {
                            areaItem.code && onCopyFoldArea ?
                                <span className={iconCls} onClick={onCopyFoldArea}>
                                    <i className="iconfont icon-fuzhikapian" title={langCheck('ZoneSetting-000212', 'pages', json)} /> {/* 国际化处理： 复制卡片*/}
                                </span>
                                :
                                <Tooltip className={iconCls} placement="top" title={langCheck('ZoneSetting-000221', 'pages', json)}> {/* 国际化处理：请先输入区域编码*/}
                                    <span onClick={onCopyFoldArea}>
                                        <i className="iconfont icon-fuzhikapian disabled" title={langCheck('ZoneSetting-000212', 'pages', json)} /> {/* 国际化处理： 复制卡片*/}
                                    </span>
                                </Tooltip>
                        }
                    </span>
                }
                <span className="btn-group">
                    {
                        /* 下移 */
                        onMoveDown && <span className={iconCls} onClick={!isLastArea && onMoveDown}>
                            <i
                                title={langCheck('ZoneSetting-000189', 'pages', json)}
                                className={`iconfont icon-xiangxia ${isLastArea ? 'disabled' : ''}`}
                            />
                        </span>
                    }

                    {
                        /* 上移 */
                        onMoveUp && <span className={iconCls} onClick={!isFirstArea && onMoveUp} >
                            <i
                                title={langCheck('ZoneSetting-000188', 'pages', json)}
                                className={`iconfont icon-xiangshang ${isFirstArea ? 'disabled' : ''}`}
                            />
                        </span>
                    }
                    {
                        /* 新增孙表 */
                        onAddGrandsonTable && <span className={iconCls} onClick={onAddGrandsonTable} >
                            <i
                                title={langCheck('ZoneSetting-000218', 'pages', json)}
                                className="iconfont icon-xinzengsunbiao"
                                style={{ fontSize: 20 }}
                            />
                        </span>
                    }
                    {/* 删除 */}
                    {
                        onDelete &&
                        <span className={iconCls}>
                            <NCPopconfirm
                                content={langCheck('ZoneSetting-000191', 'pages', json)} /* 国际化处理： 确定删除区域吗？*/
                                onClose={onDelete}
                                placement='topRight'
                            // getPopupContainer={() => document.getElementsByClassName("template-setting-page")[0]}
                            >
                                <i className="iconfont icon-shanchu" title={langCheck('ZoneSetting-000190', 'pages', json)} />
                            </NCPopconfirm>
                        </span>
                    }
                </span>
                {/* 表格区切换视图 */}
                {
                    toggleViewBtnVisible && (
                        <span className={iconCls} onClick={onToggleView}>
                            <i
                                title={langCheck('ZoneSetting-000237', 'pages', json)} /* 国际化处理： 切换视图*/
                                className={`iconfont ${isTile ? 'icon-mbpz_pp' : 'icon-Group'}`}
                            />
                        </span>
                    )
                }
            </span>
        );
    }
    typeIsTab = type => {
        return type === 'tab';
    }
    //渲染区域头部
    renderHeader = (type = 'area', params = {}) => {
        const { json, areaItem } = this.props;
        let {
            // headerTitle = areaItem.name, //区域描述有内容则显示区域描述
            headerTitle = getMultiLangText(areaItem, 'name', this.props.multiOptions),
            headerVisible = true,
            contentVisible,
            onToggleHeader,
            onDrawerToggle, //侧拉收起
            isGrandson,
        } = params;
        const toggleBtnClick = () => {
            const currentTabArea = this.getCurrentTabArea();
            onToggleHeader && onToggleHeader();
            if (!isGrandson) {this.selectAreaItem(undefined, currentTabArea);} //选中当前选中页签区域
        };
        const toggleBtn = contentVisible ? (
            <i
                title={langCheck('ZoneSetting-000011', 'pages', json)}/* 国际化处理： 收起*/
                className="iconfont icon-bottom"
                onClick={handleStopPropagation(toggleBtnClick)}
            ></i>
        ) : (
            <i
                title={langCheck('ZoneSetting-000012', 'pages', json)}/* 国际化处理： 展开*/
                className="iconfont icon-right"
                onClick={handleStopPropagation(toggleBtnClick)}
            ></i>

        );
        const style = this.typeIsTab(type) ? { height: 0 } : type === 'side' ? { display: 'flex', alignItems: 'center' } : {};
        return <div className={`area-item-header ${headerVisible ? 'show' : 'hide'}`} fieldid="header" style={style} >
            <div className="area-item-name-wrapper search-area-header" onClick={onToggleHeader}>
                <span className="area-item-name">
                    {onToggleHeader && <span className={`expand ${this.typeIsTab(type) ? 'tab' : ''}`}>{toggleBtn}</span>}
                    {/* 区域描述有内容则显示区域描述 */}
                    {!this.typeIsTab(type) && <span className="area-name">{headerTitle}</span>}
                </span>
            </div>
            {this.renderHeaderBtns(type, params)}
            {
                onDrawerToggle && <span className="drawer-close-btn" onClick={onDrawerToggle}>
                    <i className="iconfont icon-celashouqi"></i>
                </span>
            }
        </div >;
    };

    //渲染表单区分组卡片
    renderFormGroupCard = (item, groupIndex, cardIndex) => {
        let shouldHideGray = this.props.areaVisible[this.props.areaItem.pk_area] || false;
        const areaItem = this.getCurrentTabArea();
        let group = areaItem.groups && areaItem.groups[groupIndex];
        let areaIndex = this.getAreaIndexByPk(group);
        let groupBelongToFormAreaIndex = this.getAreaIndexByPk(areaItem);
        shouldHideGray = group && this.props.areaVisible[group.pk_area] || false;
        return this.renderCard({
            item,
            cardIndex,
            areaType: 'form',
            areaIndex,
            shouldHideGray,
        });
    }

    //渲染展开卡片区卡片
    renderTableFoldCard = (item, foldIndex, cardIndex, areaItem = this.props.areaItem) => {
        let fold = areaItem.sides && areaItem.sides[foldIndex];
        let areaIndex = this.getAreaIndexByPk(fold);

        return this.renderCard({
            item,
            cardIndex,
            areaType: 'form',
            areaIndex,
            shouldHideGray: fold ? (this.props.areaVisible[fold.pk_area] || false) : false,
        });
    }

    /**
     * 渲染card
     *
     * @item - queryPropertyList循环的item
     * @areaItem - 区域的item
     * @areaIndex - 区域的index
     * @cardIndex - queryPropertyList循环的index
     * @areaType - 卡片类型 search:查询字段 card:表单字段 table:表格字段
     * @groupBelongToFormAreaIndex - 表单区域分组的主表index
     */
    renderCard = ({
        item,
        areaIndex = this.props.index,
        cardIndex,
        areaType,
        shouldHideGray = this.props.areaVisible[this.props.areaItem.pk_area] || false,
        groupBelongToFormAreaIndex,
    }) => (
        <MyCard
            index={cardIndex}
            areaItem={this.props.areaItem}
            areaIndex={areaIndex}
            key={item.pk_query_property}
            shouldHideGray={shouldHideGray}
            id={item.pk_query_property}
            // name={item.label}
            name={getMultiLangText(item, 'label', this.props.multiOptions)}
            areaid={this.props.areaItem.pk_area}
            visible={item.visible}
            color={item.color}
            required={item.required}
            // selectThisCard={this.selectThisCard}
            moveCard={this.moveCard}
            deleteCard={cardIndex => this.deleteCard(cardIndex, areaIndex)}
            cardInfo={item}
            areaType={areaType}
            json={this.props.json}
            addMetaItem={this.props.addMetaItem}
            handleCheckCard={this.handleCheckCard}
            showCardCheckboxController={this.state.showCardCheckboxController}
            setCardCheckboxState={this.setCardCheckboxState}
            checkAllCard={this.checkAllCard}
            checkedCards={this.state.checkedCards}
            clearCheckedCard={this.clearCheckedCard}
            revertThisAction={this.revertThisAction}
            batchMoveCard={this.batchMoveCard}
            openAddNotMetaInArea={this.openAddNotMetaInArea}
            getCurrentTabArea={this.getCurrentTabArea}
            setRealAreaIndexAndNotMetaData={this.setRealAreaIndexAndNotMetaData}
            activeTabKey={this.state.tabObj.activeTabKey}
            setBlankDomWidth={this.setBlankDomWidth}
            groupBelongToFormAreaIndex={groupBelongToFormAreaIndex}
            getAreaIndexByPk={this.getAreaIndexByPk}
        />
    )

    //渲染表单区分组头部
    renderGroupHeader = (group, groupIndex, btns) => {
        const contentVisible = this.getGroupContentVisible(groupIndex, group.relationcode);
        return <div className="form-group-header">
            <span className="form-group-title">
                <span className="group-name">{getMultiLangText(group, 'name', this.props.multiOptions)}</span>
                <i
                    className={`iconfont ${contentVisible ? 'icon-ncc-zk' : 'icon-ncc-sq'}`}
                    onClick={e => this.toggleFormGroup(groupIndex, group.relationcode, e)}
                ></i>
            </span>
            <div className="dashed-line"></div>
            <div className="group-btns">{btns}</div>
        </div>;
    }

    //渲染多页签子表头部
    renderTabTableHeader = () => {
        let { areaItem, index, onMoveArea } = this.props;
        const currentTabArea = this.getCurrentTabArea();
        const currentTabAreaIndex = this.getAreaIndexByPk(currentTabArea); //选中多页签对应的区域id
        return this.renderHeader('tab', {
            headerVisible: true,
            contentVisible: this.props.isShow,
            foldBtnVisible: true, //展开侧拉/展开卡片按钮
            toggleViewBtnVisible: true, //切换视图按钮
            hasMeta: () => currentTabArea.metaid,
            onToggleHeader: this.showOrHideAreaItem,
            onHideGray: val => this.handleHideGray(val, currentTabArea),
            onAddMeta: () => this.addMetaInArea({
                metaId: currentTabArea.metaid,
                areaId: currentTabArea.pk_area,
                areaType: currentTabArea.areatype,
            }),
            onBatchSetting: () => this.openBatchSetting(currentTabAreaIndex),
            onSyncSetting: () => this.openSyncSetting(currentTabAreaIndex, currentTabArea),
            onCopySideArea: e => this.copySide(e, currentTabArea), //表格区显示复制侧拉按钮
            onCopyFoldArea: e => this.copyFold(e, currentTabArea), //表格区显示复制卡片按钮
            onMoveDown: () => onMoveArea('down', index),
            onMoveUp: () => onMoveArea('up', index),
            onDelete: () => this.handleDeleteArea(currentTabArea.pk_area),
            onToggleView: () => this.props.onToggleTableView(index, !areaItem.isTile), //切换表格区视图
            onToggleSide: () => this.handleToggleSideForm(undefined, currentTabArea), //展开侧拉
            onToggleFold: () => this.handleToggleFoldForm(undefined, currentTabArea), //展开下拉
            currentPkArea: currentTabArea.pk_area, // 当前 pk_area
        });
    }

    //渲染多页签主表头部
    renderTabFormHeader = () => {
        let { index, onMoveArea } = this.props;
        const currentTabArea = this.getCurrentTabArea();
        const currentTabAreaIndex = this.getAreaIndexByPk(currentTabArea); //选中多页签对应的区域id
        return this.renderHeader('tab', {
            headerVisible: true,
            contentVisible: this.props.isShow,
            hasMeta: () => currentTabArea.metaid,
            onToggleHeader: this.showOrHideAreaItem,
            onHideGray: val => this.handleHideGray(val, currentTabArea),
            onAddMeta: () => this.addMetaInArea({
                metaId: currentTabArea.metaid,
                areaId: currentTabArea.pk_area,
                areaType: currentTabArea.areatype,
            }),
            onBatchSetting: () => this.openBatchSetting(currentTabAreaIndex),
            onSyncSetting: () => this.openSyncSetting(currentTabAreaIndex, currentTabArea),
            onAddFormGroup: this.handleAddFormGroup.bind(this), //表单区显示添加分组按钮
            onMoveDown: () => onMoveArea('down', index),
            onMoveUp: () => onMoveArea('up', index),
            onDelete: () => this.handleDeleteArea(currentTabArea.pk_area),
            currentPkArea: currentTabArea.pk_area, // 当前 pk_area
        });
    }

    //渲染区域头部
    renderAreaHeader = () => {
        let { areaItem, areatype, id, index, onMoveArea } = this.props;
        //多页签子表
        if (this.isTabs('table')) {
            return this.renderTabTableHeader();
        } else if (this.isTabs('form')) { //多页签主表
            return this.renderTabFormHeader();
        }
        const handleSyncSetting = () => this.openSyncSetting(index); //批量设置同步
        return this.renderHeader('area', {
            headerVisible: true,
            contentVisible: this.props.isShow,
            foldBtnVisible: areatype === '2', //表格区显示展开侧拉/展开卡片按钮
            toggleViewBtnVisible: areatype === '2', //切换视图按钮
            hasMeta: () => areaItem.metaid,
            onToggleHeader: this.showOrHideAreaItem,
            onHideGray: this.handleHideGray,
            onAddMeta: () => this.addMetaInArea(),
            onBatchSetting: () => this.openBatchSetting(),
            onSyncSetting: areatype === '2' && handleSyncSetting, //表格区显示批量设置同步
            onAddFormGroup: areatype === '1' && this.handleAddFormGroup.bind(this), //表单区显示添加分组按钮
            onCopySideArea: areatype === '2' && this.copySide, //表格区显示复制侧拉按钮
            onCopyFoldArea: areatype === '2' && this.copyFold, //表格区显示复制卡片按钮
            onMoveDown: () => onMoveArea('down', index),
            onMoveUp: () => onMoveArea('up', index),
            onDelete: () => this.handleDeleteArea(id),
            onToggleView: () => this.props.onToggleTableView(index, !areaItem.isTile), //切换表格区视图
            currentPkArea: areaItem.pk_area, // 当前的 pk_area
            onToggleSide: e => this.handleToggleSideForm(e), //展开侧拉
            onToggleFold: e => this.handleToggleFoldForm(e), //展开下拉
        });

    }

    //获取当前选中页签区域
    getCurrentTabArea = (areaItem = this.props.areaItem) => {
        const type = areaItem.areatype === '1' ? 'form' : areaItem.areatype === '2' ? 'table' : '';
        const tabs = areaItem[TAB_FLAG[type]] || [];
        const allTabs = [areaItem].concat(tabs);
        return allTabs.find(item => item.code === this.state.tabObj.activeTabKey) || areaItem;
    }

    //渲染表单区分组
    renderFormGroup = (group, groupIndex) => {
        const isActive = this.props.selectedArea && this.props.selectedArea.pk_area === group.pk_area;
        const groupAreaIndex = this.getAreaIndexByPk(group); //分组对应的区域id
        let { groupShowArr } = this.state;
        const isFormTab = this.isTabs('form'); //是否多页签主表
        const groupArea = isFormTab ? this.getCurrentTabArea(group) : group; //选中页签主表
        const tabGroupAreaIndex = this.getAreaIndexByPk(groupArea);
        const groupHeaderBtns = this.renderHeaderBtns('group', {
            child: { groups: groupArea },
            headerVisible: isActive,
            hasMeta: () => group.metaid,
            onToggleHeader: () => this.toggleFormGroup(groupIndex, group.relationcode),
            onHideGray: val => this.handleHideGray(val, group),
            onAddMeta: () => this.addMetaInArea({
                metaId: group.metaid,
                areaId: group.pk_area,
                areaType: group.areatype,
            }),
            onBatchSetting: () => this.openBatchSetting(groupAreaIndex),
            onAddFormGroup: e => this.handleAddFormGroup.call(this, e, groupAreaIndex + 1),
            onMoveDown: () => this.props.onMoveFormGroup('down', groupAreaIndex),
            onMoveUp: () => this.props.onMoveFormGroup('up', groupAreaIndex),
            onDelete: () => this.handleDeleteArea(group.pk_area),
            currentPkArea: group.pk_area, // 当前 pk_area
        });
        const groupHeader = this.renderGroupHeader(group, groupIndex, groupHeaderBtns);
        return <div ref={ref => this[`formGroupRef${groupIndex}`] = ref}>
            <FormGroupArea
                group={group}
                groupIndex={groupIndex}
                groupShowArr={groupShowArr}
                isActive={isActive}
                contentVisible={this.getGroupContentVisible(groupIndex, group.relationcode)}
                renderHeader={groupHeader}
                renderCard={(item, index) => this.renderFormGroupCard(item, groupIndex, index)}
                emptyText={langCheck('ZoneSetting-000226', 'pages', this.props.json)} /* 国际化处理：请将元数据、非元数据添加至此 */
                onClick={e => this.selectAreaItem(e, group)}
                onDrop={monitor => this.handleSpecialAreaDrop(monitor, groupAreaIndex)}
            />
        </div>;
    }

    //渲染表格区展开侧拉
    renderTableSide = ({
        side, //侧拉数据
        sideIndex, //侧拉index
        onlyGrandson, //是否有孙表（有孙表无侧拉渲染子表）
        relationArea, //关联区域
    }) => {
        let { sideShow } = this.state.sideObj;
        const isActive = this.props.selectedArea && this.props.selectedArea.pk_area === side.pk_area;
        const sideAreaIndex = !onlyGrandson ? this.getAreaIndexByPk(side) : sideIndex; //展开侧拉对应的区域id
        const sideHeader = this.renderHeader('side', {
            // headerTitle: side.name,
            headerTitle: getMultiLangText(side, 'name', this.props.multiOptions),
            hasMeta: () => side.metaid,
            onHideGray: val => this.handleHideGray(val, side),
            onAddMeta: () => this.addMetaInArea({
                metaId: side.metaid,
                areaId: side.pk_area,
                areaType: side.areatype,
            }),
            onBatchSetting: () => this.openBatchSetting(sideAreaIndex),
            onSyncSetting: () => this.openSyncSetting(sideAreaIndex),
            onAddGrandsonTable: e => this.handleAddGrandson(e, relationArea),
            onDelete: () => {
                this.handleDeleteArea(side.pk_area)
                    .then(() => {
                        let { sideObj } = this.state;
                        sideObj.sideShow = false; //删除后收起侧拉
                        this.setState({ sideObj });
                    });
            },
            onDrawerToggle: () => this.handleToggleSideForm(undefined, relationArea),
            currentPkArea: side.pk_area, // currentPkArea
        });
        const sideCard = (item, index) => this.renderTableFoldCard(item, sideIndex, index, relationArea);
        let grandsonArea = this.props.areaItem.grandsons;
        //如果展开侧拉是多页签子表，传对应多页签的areaItem
        if (relationArea && checkAreaType.isTableTab(relationArea) && this.props.areaItem.tabs) {
            const tabIndex = this.props.areaItem.tabs.findIndex(item => item.pk_area === relationArea.pk_area);
            grandsonArea = relationArea.grandsons;
            sideShow = this.state.tabObj.sideArr[tabIndex] && this.state.tabObj.sideArr[tabIndex].sideShow;
        }
        return (
            <TableDrawerArea
                areaClassName={this.getAreaItemCls(side)}
                side={side}
                isActive={isActive}
                sideIndex={sideIndex}
                renderHeader={sideHeader}
                renderCard={sideCard}
                visible={sideShow}
                onClick={e => this.selectAreaItem(e, side)}
                onDrop={monitor => this.handleSpecialAreaDrop(monitor, sideAreaIndex)}
            >
                {/* 这里写孙表 */}
                {() => (
                    <NCDiv className="grandson-content" fieldid="grandson" areaCode={NCDiv.config.Area}>
                        {
                            grandsonArea && grandsonArea.map((grandson, index) => {
                                return this.renderGrandsonArea(grandson, index, relationArea);
                            })
                        }
                    </NCDiv>
                )}
            </TableDrawerArea>
        );
    }

    //渲染表格区展开区域 relationArea：关联区域
    renderTableFold = (fold, foldIndex, relationArea) => {
        const { foldShow } = this.state.foldObj;
        const isActive = this.props.selectedArea && this.props.selectedArea.pk_area === fold.pk_area;
        const foldAreaIndex = this.getAreaIndexByPk(fold); //展开卡片对应的区域id
        const foldHeader = this.renderHeader('area', {
            // headerTitle: fold.name,
            headerTitle: getMultiLangText(fold, 'name', this.props.multiOptions),
            contentVisible: foldShow,
            hasMeta: () => fold.metaid,
            onToggleHeader: this.handleToggleFoldForm,
            onHideGray: val => this.handleHideGray(val, fold),
            onAddMeta: () => this.addMetaInArea({
                metaId: fold.metaid,
                areaId: fold.pk_area,
                areaType: fold.areatype,
            }),
            onBatchSetting: () => this.openBatchSetting(foldAreaIndex),
            onSyncSetting: () => this.openSyncSetting(foldAreaIndex),
            onDelete: () => {
                this.handleDeleteArea(fold.pk_area)
                    .then(() => {
                        let { foldObj } = this.state;
                        foldObj.foldShow = false; //删除后收起卡片
                        this.setState({ foldObj });
                    });
            },
            currentPkArea: fold.pk_area,
        });
        const foldCard = (item, index) => this.renderTableFoldCard(item, foldIndex, index, relationArea);
        const foldCls = this.getAreaItemCls(fold, "");
        const processedCode = processClass(fold.code) || 'unknow';
        return <NCDiv className={`table-fold-area ${foldCls} search-area-${String(fold.code).replace(/\.|\&|\#/g, '') || 'unknow'} drag-mask-${processedCode}`} fieldid="table-fold" areaCode={NCDiv.config.Area}>
            <TableFoldArea
                fold={fold}
                foldIndex={foldIndex}
                isActive={isActive}
                renderHeader={foldHeader}
                renderCard={foldCard}
                visible={foldShow}
                onClick={e => this.selectAreaItem(e, fold)}
                onDrop={monitor => this.handleSpecialAreaDrop(monitor, foldAreaIndex)}
            />
        </NCDiv>;
    }

    //渲染孙表区域 relationArea:孙表关联的区域
    renderGrandsonArea = (grandson, grandsonIndex, relationArea) => {
        const isActive = this.props.selectedArea && this.props.selectedArea.pk_area === grandson.pk_area;
        const grandsonAreaIndex = this.getAreaIndexByPk(grandson); //展开侧拉对应的区域index
        const contentVisible = this.getGrandsonContentVisible(grandsonIndex);
        const isTile = this.state.grandsonObj.isTileArr[grandsonIndex]; //切换视图状态
        const isGrandsonTab = this.isTabs('table', grandson); //是否多页签孙表
        const headerType = isGrandsonTab ? 'tab' : 'area';
        const grandsonArea = isGrandsonTab ? this.getCurrentTabArea(grandson) : grandson; //选中页签孙表
        let grandsonHeader = this.renderHeader(headerType, {
            child: { grandsons: grandson },
            // headerTitle: grandsonArea.name,
            headerTitle: getMultiLangText(grandsonArea, 'name', this.props.multiOptions),
            hasMeta: () => grandsonArea.metaid,
            contentVisible,
            toggleViewBtnVisible: true, //切换视图按钮
            isTile,
            onToggleHeader: () => this.handleToggleGrandson(grandsonIndex),
            onHideGray: val => this.handleHideGray(val, grandsonArea),
            onAddMeta: () => this.addMetaInArea({
                metaId: grandsonArea.metaid,
                areaId: grandsonArea.pk_area,
                areaType: grandsonArea.areatype,
            }),
            onBatchSetting: () => this.openBatchSetting(this.getAreaIndexByPk(grandsonArea)),
            onAddGrandsonTable: !isGrandsonTab ? e => this.handleAddGrandson(e, relationArea, grandsonAreaIndex + 1) : undefined,
            onMoveDown: () => this.props.onMoveGrandson('down', grandsonAreaIndex, grandson),
            onMoveUp: () => this.props.onMoveGrandson('up', grandsonAreaIndex, grandson),
            onDelete: () => this.handleDeleteArea(grandsonArea.pk_area),
            onToggleView: () => {
                this.handleToggleGransonView(grandsonIndex);
                this.props.onToggleTableView(grandsonAreaIndex, !grandson.isTile); //改变areaList中的状态
            },
            currentPkArea: grandsonArea.pk_area,
            isGrandson: true,
        });
        const grandsonCard = ({ item, cardIndex }) => {
            let areaIndex = this.getAreaIndexByPk(grandsonArea);
            return this.renderCard({
                item,
                cardIndex,
                areaType: 'table',
                areaIndex,
                shouldHideGray: this.props.areaVisible[grandsonArea.pk_area] || false,
            });
        };
        return <GrandsonArea
            areaClassName={this.getAreaItemCls(grandson)}
            grandson={grandson}
            grandsonIndex={grandsonAreaIndex}
            isActive={isActive}
            isTile={isTile}
            contentVisible={contentVisible}
            activeTabKey={this.state.tabObj.activeTabKey}
            renderHeader={grandsonHeader}
            renderCard={grandsonCard}
            onClick={e => this.selectAreaItem(e, grandson)}
            onDrop={monitor => this.handleSpecialAreaDrop(monitor, grandsonAreaIndex)}
            onDragArea={this.props.onDragArea}
            onTabChange={this.setActiveTabKey}
            onAreaClick={this.selectAreaItem}
            onTabPaneDrop={this.handleTabTableDrop}
            multiOptions={this.props.multiOptions}
        />;
    }

    //渲染子区域（表单分组、表格侧拉、表格展开卡片等） tab:页签数据
    renderSubArea = tab => {
        const { areaItem } = this.props;
        let subArea = null;
        switch (areaItem.areatype) {
            case "1": //表单分组区域
                const formArea = this.isTabs('form') ? tab : areaItem;
                subArea = this.renderFormSubArea(formArea);
                break;
            case "2": //表格侧拉区域
                //多页签子表
                const tableArea = this.isTabs('table') ? tab : areaItem;
                subArea = this.renderTableSubArea(tableArea);
                break;
            default:
                break;
        }
        return subArea;
    }

    //渲染表格子区域
    renderTableSubArea = (areaItem = this.props.areaItem) => {
        let drawerArea = areaItem.sides && [...areaItem.sides];
        if (areaItem.grandsons) {
            drawerArea = [...drawerArea, ...areaItem.grandsons];
        }
        return drawerArea && drawerArea.map((side, index) => {
            const sideArea = drawerArea.find(item => item.areastatus === 'edit' && item.isgrandson !== true);
            //只有孙表也渲染侧拉区域
            if (side.isgrandson === true) {
                if (!sideArea) {
                    return this.renderTableSide({
                        side: areaItem,
                        sideIndex: this.props.index,
                        onlyGrandson: true,
                    });
                }
            } else {
                if (side.areastatus === 'browse') { //展开卡片
                    return this.renderTableFold(side, index, areaItem);
                } else if (side.areastatus === 'edit') { //侧拉编辑
                    return this.renderTableSide({ side, sideIndex: index, relationArea: areaItem });
                }
            }
        });
    }

    //渲染主表分组
    renderFormSubArea = (areaItem = this.props.areaItem) => {
        return areaItem.groups && areaItem.groups.map((group, index) => {
            return this.renderFormGroup(group, index);
        });
    }
    /**
     * 渲染表格区操作列
     *
     * @param onToggleSide 切换侧拉显隐事件
     * @param onToggleFold 切换下拉显隐事件
     *
     */
    renderTableOperateCol = (onToggleSide, onToggleFold) => {
        const { json, isImplement, areaHide } = this.props;
        const areaItem = this.getCurrentTabArea();
        const foldText = this.state.foldObj.foldShow ?
            langCheck('ZoneSetting-000217', 'pages', json) : /* 国际化处理：收起卡片 */
            langCheck('ZoneSetting-000215', 'pages', json); /* 国际化处理：展开卡片 */
        let currentArea = null,
            currentPk = null;
        let renderSide = () => {
            // 侧拉PK
            currentArea = areaItem.sides && areaItem.sides.find(item => item.areastatus === 'edit');
            currentPk = currentArea && currentArea.pk_area;
            //模板设置没有侧拉隐藏掉展开侧拉按钮
            if (isImplement && (areaItem.sides && !areaItem.sides.find(item => item.areastatus === 'edit')) && (!areaItem.grandsons || areaItem.grandsons.length === 0)) {
                return null;
            } else if (areaItem.code) {
                // 这个逻辑 嵌套 需要后续改下
                // 区域隐藏 禁用侧拉按钮
                if (isImplement && areaHide[currentPk]) {
                    return (
                        <Tooltip placement="top" title={langCheck('ZoneSetting-000258', 'pages', json)}> {/* 国际化处理：请先输入区域编码*/}
                            <a className="disabled">{langCheck('ZoneSetting-000216', 'pages', json)}</a>{/* 国际化处理： 展开侧拉*/}
                        </Tooltip>
                    );
                }
                return (
                    <span>
                        <a className="search-action-side" onClick={onToggleSide}>{langCheck('ZoneSetting-000216', 'pages', json)}</a>{/* 国际化处理： 展开侧拉*/}
                    </span>
                );
            } else {
                return (
                    <Tooltip placement="top" title={langCheck('ZoneSetting-000221', 'pages', json)}> {/* 国际化处理：请先输入区域编码*/}
                        <a className="disabled">{langCheck('ZoneSetting-000216', 'pages', json)}</a>{/* 国际化处理： 展开侧拉*/}
                    </Tooltip>
                );
            }
        };
        let renderFold = () => {
            // 卡片PK
            currentArea = areaItem.sides && areaItem.sides.find(item => item.areastatus === 'browse');
            currentPk = currentArea && currentArea.pk_area;
            //模板设置没有侧拉隐藏掉展开卡片按钮
            if (isImplement && (areaItem.sides && !areaItem.sides.find(item => item.areastatus === 'browse'))) {
                return null;
            } else if (areaItem.code) {
                // 这个逻辑 嵌套 需要后续改下
                // 区域隐藏 禁用卡片按钮
                if (isImplement && areaHide[currentPk]) {
                    return (
                        <Tooltip placement="top" title={langCheck('ZoneSetting-000257', 'pages', json)}> {/* 国际化处理：请先输入区域编码*/}
                            <a className="disabled">{langCheck('ZoneSetting-000215', 'pages', json)}</a>{/* 国际化处理： 展开侧拉*/}
                        </Tooltip>
                    );
                }
                return (
                    <span>
                        <a className="search-action-fold" onClick={onToggleFold}>{foldText}</a> {/* 国际化处理： 展开卡片*/}
                    </span>
                );
            } else {
                return (
                    <Tooltip placement="top" title={langCheck('ZoneSetting-000221', 'pages', json)}> {/* 国际化处理：请先输入区域编码*/}
                        <a className="disabled">{foldText}</a>
                    </Tooltip>
                );
            }
        };
        //模板设置没设置展开侧拉/卡片隐藏操作列
        if (this.hideTableOprCol()) {
            return null;
        }
        return [renderSide(), renderFold()];
    }

    //校验是否显示表格区操作列
    hideTableOprCol = () => {
        const { areaItem, isImplement } = this.props;
        //有孙表不隐藏操作列
        if (areaItem.grandsons && areaItem.grandsons.length > 0) {
            return false;
        } else {
            return isImplement && (!areaItem.sides || areaItem.sides && areaItem.sides.length === 0);
        }
    }

    //设置多页签子表选中页签
    setActiveTabKey = (activeTabKey, expand) => {
        let { tabObj } = this.state;
        tabObj.activeTabKey = activeTabKey;
        console.log(this.props.selectedArea);
        if (activeTabKey !== this.props.selectedArea.code) {
            this.showOrHideAreaItem(true);
        } else {
            this.showOrHideAreaItem(expand);
        }
        this.setState({ tabObj });
    }

    //多页签子表拖放
    handleTabTableDrop = monitor => {
        //只拖拽到多页签区域时执行（而不是嵌套组件）
        if (monitor.isOver({ shallow: false })) {
            const currentTabAreaIndex = this.getAreaIndexByPk(this.getCurrentTabArea());
            this.handleSpecialAreaDrop(monitor, currentTabAreaIndex);
        }
    }

    //处理选中卡片
    handleCheckCard = (value, cardInfo) => {
        let checkedCards = this.state.checkedCards[cardInfo.areaid];
        if (value) {
            if (checkedCards) {
                checkedCards.push(cardInfo.code);
            } else {
                checkedCards = [cardInfo.code];
            }

            let checkedCardsController = {
                ...this.state.checkedCards,
                [cardInfo.areaid]: checkedCards,
            };
            this.setState({ checkedCards: checkedCardsController });
        } else {
            let index = checkedCards.findIndex(item => item === cardInfo.code);
            checkedCards.splice(index, 1);
            let checkedCardsController = {
                ...this.state.checkedCards,
                [cardInfo.areaid]: checkedCards,
            };
            this.setState({ checkedCards: checkedCardsController });
        }
    };

    //设置卡片的checkbox是否可见
    setCardCheckboxState = cardInfo => {
        let { showCardCheckboxController } = this.state;
        let { areaItem } = this.props;
        let changedController = {
            ...showCardCheckboxController,
            [cardInfo.areaid]: !showCardCheckboxController[cardInfo.areaid],
        };

        /*if (areaItem.areatype === '1' && areaItem.groups && areaItem.groups.length > 0) {
            areaItem.groups.forEach(item => {
                changedController[item.pk_area] = !showCardCheckboxController[areaItem.pk_area]
            });
            changedController[areaItem.pk_area] = !showCardCheckboxController[areaItem.pk_area]
        }*/

        this.setState({ showCardCheckboxController: changedController });
    };

    //选中所有卡片
    checkAllCard = cardInfo => {
        let areaItem = this.props.areaList.find(item => item.pk_area === cardInfo.areaid);
        let identities = areaItem && areaItem.queryPropertyList.map(item => item.code);
        this.setState({
            checkedCards: {
                ...this.state.checkedCards,
                [cardInfo.areaid]: identities,
            },
        });
    };

    //清空所有卡片选中状态
    clearCheckedCard = cardInfo => {
        this.setState({
            checkedCards: {
                ...this.state.checkedCards,
                [cardInfo.areaid]: [],
            },
        });
    };

    //撤销这次选择
    revertThisAction = cardInfo => {
        let { showCardCheckboxController, checkedCards } = this.state;
        let { areaItem } = this.props;
        let changedController = {
            ...showCardCheckboxController,
            [cardInfo.areaid]: false,
        };

        this.setState({
            checkedCards: {
                ...checkedCards,
                [cardInfo.areaid]: [],
            },
            showCardCheckboxController: changedController,
        });
    };

    //批量移动
    batchMoveCard = (cardInfo, direction) => {
        let { areaList } = this.props;
        let { checkedCards } = this.state;
        let { code, areaid } = cardInfo;

        areaList = _.cloneDeep(areaList);
        let index = areaList.findIndex(item => item.pk_area === cardInfo.areaid);
        let cards = areaList[index].queryPropertyList;
        let selectedCardsInfo = [];

        //如果目标位置包含在已选中的列表中就从列表中移出
        if (checkedCards[areaid].includes(code)) {
            let targetIndex = checkedCards[areaid].indexOf(code);
            checkedCards[areaid].splice(targetIndex, 1);
        }
        //sonar未通过，更改写法
        // for (var i = 0; i < cards.length; i++) {
        //     let item = cards[i];
        //     if (checkedCards[areaid].includes(item.code)) {
        //         cards.splice(i, 1);
        //         selectedCardsInfo.push(item);
        //         i--;
        //     } 
        // }
        let i = 0;
        while (i < cards.length) {
            let item = cards[i];
            if (checkedCards[areaid].includes(item.code)) {
                cards.splice(i, 1);
                selectedCardsInfo.push(item);
            } else {
                i++;
            }
        }
        let movePosition;

        cards.forEach((item, index) => {
            if (item.code === code) {
                movePosition = index;
            }
        });

        movePosition = direction === 'front' ? movePosition : movePosition + 1;
        cards.splice(movePosition, 0, ...selectedCardsInfo);
        cards.forEach((item, index) => {
            item.position = index + 1;
        });
        this.props.updateAreaList(areaList);
    };

    setRealAreaIndexAndNotMetaData = ({ currentNotMeta, realAreaIndex }) => {
        this.setState({
            currentNotMeta,
            realAreaIndex,
        });
    };

    setBlankDomWidth = () => {
        let blankDom = this.areaItemDom && this.areaItemDom.querySelector('.property-item.is-blank-dom');
        if (blankDom) {
            blankDom.style.width = '0px';
        }
    };

    render() {
        const { connectDragSource, connectDropTarget, areaList, index, areaItem, areaHide } = this.props;
        const { syncSettingModalVisible } = this.state;
        let areaClassName = this.getAreaItemCls(areaItem);
        const areaStyle = areaList[index] && areaList[index].validate === false ? { borderColor: '#f5222d' } : {};
        const processedCode = processClass(areaItem.code) || 'unknow';
        const tabMaskCls = !this.isTabs(areaItem.areatype === '1' ? 'form' : areaItem.areatype === '2' ? 'table' : '') ? `drag-mask-${processedCode}` : '';
        return !areaHide[areaItem.pk_area] && connectDragSource(
            connectDropTarget(
                <div
                    type="ncdiv" //由于dnd只能接受div，所以这里模拟NCDiv
                    fieldid={`${areaItem.code}_area`} //自动化测试标记
                    className={areaClassName + ` search-area-${String(areaItem.code).replace(/\.|\&|\#/g, '') || 'unknow'} ${tabMaskCls}`}
                    searchinside={String(this.state.sideObj.sideShow)}
                    onClick={this.selectAreaItem}
                    style={areaStyle}
                    ref={dom => this.areaItemDom = dom}
                >
                    <BaseAreaItem
                        isShow={this.props.isShow}
                        isTile={areaItem.isTile}
                        areaItem={this.props.areaItem}
                        renderHeader={this.renderAreaHeader()}
                        renderCard={this.renderCard}
                        activeTabKey={this.state.tabObj.activeTabKey}
                        onAreaClick={this.selectAreaItem}
                        onTabChange={this.setActiveTabKey}
                        onTabPaneDrop={this.handleTabTableDrop}
                        multiOptions={this.props.multiOptions}
                    >
                        {tab => this.renderSubArea(tab)}
                    </BaseAreaItem>
                    {
                        this.state.batchSettingModalVisibel &&
                        <BatchSettingModal
                            batchSettingModalVisibel={
                                this.state.batchSettingModalVisibel
                            }
                            areaIndex={this.state.realAreaIndex}
                            setModalVisibel={this.setModalVisibel}
                            json={this.props.json}
                            multiOptions={this.props.multiOptions}
                        />
                    }
                    <AddNotMetaDataModal
                        areatype={this.props.areatype}
                        addDataModalVisibel={this.state.addDataModalVisibel}
                        areaIndex={this.state.realAreaIndex}
                        setAddDataModalVisibel={this.setAddDataModalVisibel}
                        json={this.props.json}
                        propperty={this.state.currentNotMeta}
                        pcode={this.props.pcode}
                        appcode={this.props.appcode}
                        templetid={this.props.templetid}
                        zoneFormData={this.props.zoneFormData}
                        multiOptions={this.props.multiOptions}
                    />
                    {
                        syncSettingModalVisible &&
                        <AreaSyncModal
                            show={syncSettingModalVisible}
                            areaIndex={this.state.syncAreaIndex}
                            close={this.setSyncModalVisible}
                            json={this.props.json}
                            multiOptions={this.props.multiOptions}
                        />
                    }
                </div>,
            ),
        );
    }
}
export default connect(
    state => ({
        selectedArea: state.zoneSettingData.selectedArea,
        areaList: state.zoneSettingData.areaList,
        newAreaList: state.zoneSettingData.newAreaList,
        selectCard: state.zoneSettingData.selectCard,
        zoneFormData: state.zoneSettingData.zoneFormData,
        isImplement: state.zoneSettingData.isImplement,
        areaVisible: state.zoneSettingData.areaVisible,
        areaHide: state.zoneSettingData.areaHide,
    }),
    {
        updateSelectCard,
        updateSelectArea,
        updateBatchSource,
        updateSearchBox,
        updateAreaList,
        setAreaItemVisible,
    },
)(AreaItem);
